import { Routes } from '@angular/router';

import { RoutesMapper } from './routes-mapper';
import { LoginComponent } from './components/login/login.component';
import { authGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { SigninLoadComponent } from './components/signin-load/signin-load.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { HomeComponent } from './components/home/home.component';
import { UserPhilSideNavComponent } from './common-components/phil-side-nav/user-phil-side-nav/user-phil-side-nav.component';
import { AdminPhilSideNavComponent } from './common-components/phil-side-nav/admin-phil-side-nav/admin-phil-side-nav.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: RoutesMapper.PRELOGIN,
    pathMatch: 'full'
  },
  {
    path: '',
    component: UserPhilSideNavComponent,
    children: [
      {
        path: RoutesMapper.NEW_DEPOSIT,
        loadComponent: () =>
          import('./components/single-entry-form/single-entry.component').then(
            (c) => c.SingleEntryComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: RoutesMapper.TRANSACTION,
        loadComponent: () =>
          import(
            './components/all-transactions/all-transactions.component'
          ).then((c) => c.AllTransactionsComponent),
        canActivate: [authGuard],
      },
      {
        path: RoutesMapper.MY_FAMILY,
        loadComponent: () =>
          import('./components/my-family/my-family.component').then(
            (c) => c.MyFamilyComponent
          ),
        // canActivate: [authGuard],
      },
      {
        path: RoutesMapper.DEPOSIT_CODES,
        loadComponent: () =>
          import('./components/deposit-codes/deposit-codes.component').then(
            (c) => c.DepositCodesComponent
          ),
        canActivate: [authGuard],
      },
      {
        path: RoutesMapper.ALL_TRANSACTION,
        loadComponent: () => import('./components/master-transactions/master-transactions.component').then((c) => c.MasterTransactionsComponent),
        canActivate: [authGuard],
      },
      {
        path: RoutesMapper.CANCEL,
        loadComponent: () => import('./components/single-entry-form/cancel/cancel.component').then((c) => c.CancelComponent),
        canActivate: [authGuard],
      },
      // {
      //   path: RoutesMapper.ALL_FC,
      //   loadComponent: () => import('./components/all-family-codes-main/single-entry-form/single-entry.component').then((c) => c.SingleEntryComponent),
      //   canActivate: [authGuard]
      // }
    ],
  },
  {
    path: RoutesMapper.ADMIN,
    component: UserPhilSideNavComponent,
    children: [
      {
        path: RoutesMapper.ALL_TRANSACTION,
        loadComponent: () => import('./components/master-transactions/master-transactions.component').then((c) => c.MasterTransactionsComponent),
        canActivate: [authGuard],
      },
      {
        path: RoutesMapper.SUBMIT_ARGHYA,
        loadComponent: () => import('./components/all-family-codes-main/single-entry-form/admin-single-entry.component').then((c) => c.AdminSingleEntryComponent),
        canActivate: [authGuard],
      },
      {
        path: RoutesMapper.ALL_FC,
        loadComponent: () => import('./components/manage-fc-codes/manage-fc-codes.component').then((c) => c.ManageFcCodesComponent),
        canActivate: [authGuard],
      },
      {
        path: RoutesMapper.PENDING_FAMILY_CODES,
        loadComponent: () => import('./components/pending-family-codes/pending-family-codes.component').then((c) => c.PendingFamilyCodesComponent),
        canActivate: [authGuard],
      },
      {
        path: RoutesMapper.CANCEL,
        loadComponent: () => import('./components/single-entry-form/cancel/cancel.component').then((c) => c.CancelComponent),
        canActivate: [authGuard],
      },
      {
        path: RoutesMapper.GENERATE_FC,
        loadComponent: () => import('./components/generate-new-fc-form/generate-new-fc-form.component').then((c) => c.GenerateNewFcFormComponent),
        canActivate: [authGuard]
      }
    ],
  },
  {
    path: RoutesMapper.LANDING_PAGE,
    component: LandingPageComponent,
    canActivate: [LoginGuard],
    children: [
      {
        path: RoutesMapper.HOME,
        loadComponent: () => import('./components/home/home.component').then((c) => c.HomeComponent),
      },
    ]
  },
  {
    path: RoutesMapper.LOGIN,
    component: SigninLoadComponent,
    canActivate: [LoginGuard],
  },
  {
    path: RoutesMapper.PRELOGIN,
    component: LoginComponent,
    // canActivate: [LoginGuard],
  },
  {
    path: RoutesMapper.GENERATE_FC_USER,
    loadComponent: () => import('./components/generate-new-fc-form/generate-new-fc-form.component').then((c) => c.GenerateNewFcFormComponent),
  }
];
